import { getWishlist, onWishlistChange } from '@theme/wishlist-store';

/**
 * <s-wishlist-count> — keeps the header wishlist link's badge and label current.
 *
 * Markup: a descendant [data-wishlist-badge] (visible count) and an <a> whose
 * aria-label is rebuilt from data-label-template, where [count] is replaced
 * with the number of saved products.
 */
class SWishlistCount extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    this.#render(getWishlist().length);
    onWishlistChange((handles) => this.#render(handles.length), this.#ac.signal);
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  /** @param {number} count */
  #render(count) {
    const badge = this.querySelector('[data-wishlist-badge]');
    if (badge instanceof HTMLElement) {
      badge.textContent = String(count);
      badge.hidden = count === 0;
    }
    const template = this.dataset.labelTemplate;
    if (template) this.querySelector('a')?.setAttribute('aria-label', template.replace('[count]', String(count)));
  }
}

customElements.define('s-wishlist-count', SWishlistCount);
